import { useAuth } from '../contexts/AuthContext';

export default function SubscriptionGate({ onShowPricing }) {
  const { user, profile, signOut } = useAuth();

  const trialEndDate = profile?.trial_ends_at
    ? new Date(profile.trial_ends_at).toLocaleDateString('he-IL', {
        day: 'numeric', month: 'long', year: 'numeric'
      })
    : null;

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#f1f5f9',
      fontFamily: "'Segoe UI', -apple-system, sans-serif",
      direction: 'rtl',
    }}>
      <div style={{
        background: 'white',
        borderRadius: 20,
        padding: '48px 40px',
        maxWidth: 480,
        width: '90%',
        textAlign: 'center',
        boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
      }}>
        <div style={{ fontSize: 52, marginBottom: 16 }}>🔒</div>
        <h2 style={{ fontSize: 22, fontWeight: 800, color: '#1e293b', margin: '0 0 12px' }}>
          תקופת הניסיון הסתיימה
        </h2>
        {trialEndDate && (
          <p style={{ color: '#64748b', fontSize: 14, margin: '0 0 6px' }}>
            תקופת הניסיון הסתיימה ב-{trialEndDate}
          </p>
        )}
        <p style={{ color: '#64748b', fontSize: 14, margin: '0 0 24px' }}>
          לחידוש הגישה, בחר/י חבילה שמתאימה לך
        </p>

        {onShowPricing && (
          <button
            onClick={onShowPricing}
            style={{
              width: '100%',
              padding: '14px 24px',
              background: 'linear-gradient(135deg, #4338ca 0%, #6366f1 100%)',
              color: 'white',
              border: 'none',
              borderRadius: 12,
              cursor: 'pointer',
              fontSize: 16,
              fontWeight: 700,
              marginBottom: 12,
              boxShadow: '0 4px 14px rgba(67,56,202,0.35)',
            }}
            onMouseEnter={e => e.currentTarget.style.opacity = '0.9'}
            onMouseLeave={e => e.currentTarget.style.opacity = '1'}
          >
            🔄 לחידוש / רכישת מנוי
          </button>
        )}

        <div style={{ marginBottom: 24 }} />

        <p style={{ fontSize: 12, color: '#94a3b8', marginBottom: 16 }}>
          מחובר/ת כ: {user?.email}
        </p>
        <button
          onClick={signOut}
          style={{
            padding: '10px 28px',
            border: '1px solid #e2e8f0',
            borderRadius: 8,
            background: 'white',
            cursor: 'pointer',
            fontSize: 13,
            color: '#64748b',
            fontWeight: 500,
          }}
          onMouseEnter={e => e.currentTarget.style.background = '#f8fafc'}
          onMouseLeave={e => e.currentTarget.style.background = 'white'}
        >
          התנתקות
        </button>
      </div>
    </div>
  );
}
